import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-doc',
  templateUrl: './doc.component.html',
  styleUrls: ['./doc.component.scss']
})
export class DocComponent implements OnInit {

  @Input() data: any;
  @Input() schema: any;
  columns: string [] = [];
  constructor() { }

  async ngOnInit() {
    this.getItems();
  }
  saveApi() {
  }
  deletearrayColumn(a, column) {
      this.data[column].splice(a, 1);
  }
  getItems() {
    // for (const item of this.data) {
    //   this.columns = [];
    for (const itemval in this.data) {
      this.columns.push(itemval);
      // if (this.typeof(this.data.itemval) === 'don\'t know' || this.typeof(this.data.itemval) === 'undefined') {
      //   this.data[itemval] = null;
      // } else if (this.typeof(this.data.itemval) === 'String') {
      //   this.data[itemval] = '';
      // }
    }
  }
  saveDescription(attr, column, value) {
    attr[column] = value;
  }
  addColumn(data) {
    let temp = JSON.parse(JSON.stringify(this.schema));
    data.push(temp);
  }
  typeof(object) {
    let stringConstructor = 'test'.constructor;
    let arrayConstructor = [].constructor;
    let objectConstructor = ({}).constructor;

    if (object === null) {
      return 'null';
    }
    if (object === undefined) {
      return 'undefined';
    }
    if (object.constructor === stringConstructor) {
      return 'String';
    }
    if (object.constructor === arrayConstructor) {
      return 'array';
    }
    if (object.constructor === objectConstructor) {
      return 'object';
    }
    {
      return 'don\'t know';
    }
  }
  stringifyjson(val) {
    return JSON.stringify(val);
  }
}
